"use strict";
/* eslint-disable max-lines */
/* eslint-disable functional/prefer-readonly-type */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatProductResponse = exports.convertToImmutable = exports.parseRawProducts = exports.getProductNodeId = exports.transformAttributes = exports.parseVariants = exports.attributesToObject = exports.getLocalizedString = exports.commerceToolsRequestDynamicPackageList = exports.commercetoolsRequestCartDiscount = exports.commercetoolsRequestDiscountCode = exports.commercetoolsRequestProducts = void 0;
const isNotNaN_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/isNotNaN"));
const isNotNil_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/isNotNil"));
const transformObject_1 = __importDefault(require("@simplisafe/ewok/transformObject"));
const immutable_1 = require("immutable");
const monet_1 = require("monet");
const lensProp_1 = __importDefault(require("ramda/src/lensProp"));
const over_1 = __importDefault(require("ramda/src/over"));
const path_1 = __importDefault(require("ramda/src/path"));
const pathOr_1 = __importDefault(require("ramda/src/pathOr"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const propOr_1 = __importDefault(require("ramda/src/propOr"));
const props_1 = __importDefault(require("ramda/src/props"));
const propSatisfies_1 = __importDefault(require("ramda/src/propSatisfies"));
const reduce_1 = __importDefault(require("ramda/src/reduce"));
const ts_functional_pipe_1 = require("ts-functional-pipe");
const config_1 = require("../config");
const dynamicPackages_1 = require("../dynamicPackages");
const commercetools_1 = require("../secrets/commercetools");
const safeFind_1 = require("../utils/safeFind");
const safePath_1 = require("../utils/safePath");
const safeProp_1 = require("../utils/safeProp");
const commercetoolsClient_1 = require("./commercetoolsClient");
const discounts_1 = require("./discounts");
const locale_1 = require("./locale");
const price_1 = require("./price");
const restockDateProp = () => {
    return (0, config_1.getLocale)() === 'en-GB' ? 'restock_date_uk' : 'restock_date_us';
};
const HARDWARE_VERSION = 'hardware-version';
/**
 * Returns a Future that is either Error or Maybe ProductResponse.
 *
 * This request isn't finalized yet and will most likely change as we continue to work on our separate locales,
 * but the response will contain the same product type of ProductProjection.
 *
 * Locale isn't currently used, but it will be soon so it's included to avoid refactoring in the future.
 */
const commercetoolsRequestProducts = (locale) => {
    const { country, currency, priceChannel } = locale_1.localeInfo[locale];
    return (0, commercetoolsClient_1.commercetoolsFetch)({
        endpoint: `${commercetools_1.productUrl}/product-projections/search?priceCurrency=${currency}&priceCountry=${country}&priceChannel=${priceChannel}&limit=500`,
        method: 'GET'
    });
};
exports.commercetoolsRequestProducts = commercetoolsRequestProducts;
/**
 * To get the details of the given disount code which returns a Future that is either Error or Maybe DiscountCodePagedQueryResponse.
 *
 * @param locale
 * @param promoCodeParam
 */
const commercetoolsRequestDiscountCode = (locale, promoCodeParam) => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.productUrl}/discount-codes?where=${promoCodeParam}&expand=cartDiscounts[*].id`,
    method: 'GET'
});
exports.commercetoolsRequestDiscountCode = commercetoolsRequestDiscountCode;
/**
 * To get the details of the given promo key which returns a Future that is either Error or Maybe CartDiscount.
 *
 * @param locale
 * @param promoKeyParam
 */
const commercetoolsRequestCartDiscount = (__locale, promoKeyParam) => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.productUrl}/cart-discounts/key=${promoKeyParam}`,
    method: 'GET'
});
exports.commercetoolsRequestCartDiscount = commercetoolsRequestCartDiscount;
const commerceToolsRequestDynamicPackageList = (locale) => (attributeHash) => (0, dynamicPackages_1.ctDynamicPackageListFetch)({
    attributeHash,
    locale
});
exports.commerceToolsRequestDynamicPackageList = commerceToolsRequestDynamicPackageList;
// https://api.qa.commerce.simplisafe.com/qa/products/qa/v1/product-projections/key=SSFS3?priceCurrency=GBP&priceCountry=GB
/**
 * Get a string value from an object with locales as keys
 * @deprecated the localized value should be stored/returned from redux already
*/
const getLocalizedString = (locale) => (v) => (0, prop_1.default)(locale, v) || (0, prop_1.default)('en-US', v);
exports.getLocalizedString = getLocalizedString;
const attributesLens = (0, lensProp_1.default)('attributes');
const attributesToObject = (attributes) => attributes.reduce((acc, item) => ({
    ...acc,
    [(0, prop_1.default)('name', item)]: (0, prop_1.default)('value', item)
}), {});
exports.attributesToObject = attributesToObject;
const parseVariants = (product) => (0, safeProp_1.safeProp)('variants', product)
    .map(variant => variant.map((0, ts_functional_pipe_1.pipe)(
// TODO: this will be cleaned up once I'm done switching over to use better lenses
// @ts-ignore
val => (0, over_1.default)(attributesLens, exports.attributesToObject)(val), (0, transformObject_1.default)({
    hardwareVersion: (0, pathOr_1.default)('', ['attributes', HARDWARE_VERSION]),
    isCartable: (0, pathOr_1.default)(true, ['attributes', 'is_cartable']),
    isIndeterminatePrice: (0, pathOr_1.default)(false, ['attributes', 'indeterminatePrice']),
    // these are assumed to be true unless otherwise
    isOnStock: (0, pathOr_1.default)(true, ['availability', 'channels', locale_1.LOCALE_INFO.priceChannel, 'isOnStock']),
    isSellable: (0, pathOr_1.default)(true, ['attributes', 'is_sellable']),
    isViewable: (0, pathOr_1.default)(true, ['attributes', 'is_viewable']),
    price: (0, ts_functional_pipe_1.pipe)((0, path_1.default)(['price', 'value']), rawPrice => rawPrice ? (0, price_1.formatCTPriceToNumber)(rawPrice) : NaN),
    productName: val => (0, propOr_1.default)({}, 'productName', val),
    quantity: val => (0, propOr_1.default)(NaN, 'quantity', val),
    restockDate: (0, pathOr_1.default)('', ['attributes', restockDateProp()]),
    sku: val => (0, propOr_1.default)('', 'sku', val),
}))))
    .getOrElse([]);
exports.parseVariants = parseVariants;
/**
 * Transforms the attributes array on a product into an object with key value pairs
 */
const transformAttributes = (source) => {
    const attributes = (0, path_1.default)(['masterVariant', 'attributes'], source) || [];
    // TODO: something is off with the type coming in from contentful and what we're putting out
    return {
        ...source,
        masterVariant: {
            ...source.masterVariant,
            attributes: (0, exports.attributesToObject)(attributes)
        },
    };
};
exports.transformAttributes = transformAttributes;
const getProductNodeId = (product) => (0, safePath_1.safePath)(['masterVariant', 'attributes'], product)
    .map(attrs => (0, props_1.default)([`${locale_1.LOCALE_INFO.domain}-node-id`, 'node-id'], attrs))
    .chain((0, safeFind_1.safeFind)(isNotNil_1.default))
    .orJust(0);
exports.getProductNodeId = getProductNodeId;
/** Parse array of CT ProductProjections and return an array of simplified products with invalid prices and skus removed */
exports.parseRawProducts = (0, ts_functional_pipe_1.pipe)(val => val.map((0, ts_functional_pipe_1.pipe)(exports.transformAttributes, (0, transformObject_1.default)({
    '@@type': () => 'product',
    discountedPrice: discounts_1.simplifyProductDiscountedPrice,
    discountedPriceWithServicePlan: () => (0, monet_1.None)(),
    hardwareVersion: source => (0, safePath_1.safePath)(['masterVariant', 'attributes', HARDWARE_VERSION], source).getOrElse(''),
    id: (0, prop_1.default)('id'),
    isCartable: source => (0, safePath_1.safePath)(['masterVariant', 'attributes', 'is_cartable'], source).getOrElse(true),
    isIndeterminatePrice: source => (0, safePath_1.safePath)(['masterVariant', 'attributes', 'indeterminatePrice'], source).getOrElse(false),
    isOnStock: source => 
    // todo collapse this to a single safePath once project is upgraded to Monda >3.0.0
    // https://github.com/simplisafe/monda/pull/29
    (0, safePath_1.safePath)(['masterVariant', 'availability', 'channels', locale_1.LOCALE_INFO.priceChannel], source)
        .chain((0, safeProp_1.safeProp)('isOnStock'))
        .getOrElse(true),
    isSellable: source => (0, safePath_1.safePath)(['masterVariant', 'attributes', 'is_sellable'], source).getOrElse(true),
    isViewable: source => (0, safePath_1.safePath)(['masterVariant', 'attributes', 'is_viewable'], source).getOrElse(true),
    masterSku: source => (0, safePath_1.safePath)(['masterVariant', 'sku'], source).getOrElse(''),
    name: (0, prop_1.default)('name'),
    nodeId: exports.getProductNodeId,
    price: price_1.simplifyProductPrice,
    productTypeId: source => (0, safePath_1.safePath)(['productType', 'id'], source).getOrElse(''),
    restockDate: source => (0, safePath_1.safePath)(['masterVariant', 'attributes', restockDateProp()], source).getOrElse(''),
    sku: source => (0, safePath_1.safePath)(['masterVariant', 'sku'], source).getOrElse(''),
    variants: exports.parseVariants
}))), val => val.filter((0, propSatisfies_1.default)(isNotNaN_1.default, 'price')), val => val.filter((0, propSatisfies_1.default)(isNotNil_1.default, 'sku')));
/** Transform array of products into an immutable map of products using the masterSku as keys */
exports.convertToImmutable = (0, reduce_1.default)((acc, item) => {
    const sku = (0, prop_1.default)('masterSku', item);
    return acc.set(sku, item);
}, (0, immutable_1.Map)({}));
/** Convert raw product response into an Immutable Map of simplified products */
const formatProductResponse = (res) => res.chain((0, safeProp_1.safeProp)('results'))
    .toEither(Error('Product response does not contain any results'))
    .map(exports.parseRawProducts)
    .map(exports.convertToImmutable);
exports.formatProductResponse = formatProductResponse;
//# sourceMappingURL=products.js.map